import { render, staticRenderFns } from "./BcWizard.vue?vue&type=template&id=646a6936&scoped=true"
import script from "./BcWizard.vue?vue&type=script&lang=js"
export * from "./BcWizard.vue?vue&type=script&lang=js"
import style0 from "./BcWizard.vue?vue&type=style&index=0&id=646a6936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646a6936",
  null
  
)

export default component.exports